import { render } from "./ArchiveEmployeeDialog.vue?vue&type=template&id=7774515e&scoped=true"
import script from "./ArchiveEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./ArchiveEmployeeDialog.vue?vue&type=script&lang=js"

import "./ArchiveEmployeeDialog.vue?vue&type=style&index=0&id=7774515e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7774515e"]])

export default __exports__